import { RemoveAuthorization, RemoveAuthorizationVariables } from 'globalTypes'

import { useMutation } from '@apollo/client'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from 'Root/App/Button'

import styles from './index.module.css'
import MUTATION from './remove-authorization.graphql'

interface Props {
  id: string
}

library.add(faTrashAlt)

const RemoveButton = ({ id }: Props) => {
  const [mutate] = useMutation<
    RemoveAuthorization,
    RemoveAuthorizationVariables
  >(MUTATION, {
    refetchQueries: ['FetchElementAuthorizations'],
  })

  const onClick = () =>
    mutate({
      variables: {
        id,
      },
    })

  return (
    <Button className={styles.button} size="S" type="button" onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'trash-alt']} />
    </Button>
  )
}

export default RemoveButton
